import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { DocumentClient, DocumentServiceClient, DocumentServices, Documents, ServiceProvider, ServiceProvidersClient } from "src/app/web-api-client";

@Component({
  selector: 'app-documentService-creation',
  templateUrl: './documentService-creation.component.html',
  styleUrls: ['./documentService-creation.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class DocumentServiceCreationComponent implements OnInit {

  public idService: number;
  public isLoaded = false;
  public onClose = new Subject<boolean>();
  public isRequiredSelected: boolean = false;
  public order: number = 0;

  Form: FormGroup;

  public service = new DocumentServices();
  public documents: Documents[] = [];
  public selectedDocument: Documents;
  constructor(private fb: FormBuilder,public cdr:ChangeDetectorRef, public activeModal: NgbActiveModal, public documentClient: DocumentClient, public client: DocumentServiceClient) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.isLoaded = false;

    this.documentClient.getList().subscribe(r => {

      this.documents = r;

      this.Form = this.fb.group({
        isActive: [true, Validators.required],
        order: [0, Validators.required],
        isRequired: [false, Validators.required],
        isDownloadable: [false, Validators.required],
      });
    });


    this.isLoaded = true;
    this.cdr.detectChanges();

  }

  onDocumentChange(selectedValue: string) {

    this.selectedDocument = this.documents.find(d => d.idDocument == +selectedValue);
    this.cdr.detectChanges();
  }

  onCheckboxChange(isChecked: any) {
    this.isRequiredSelected = isChecked.checked;
  }


  onOrderInputChange(event: any) {
    this.order = +event.value;
  }

  onSubmit() {
    if (this.Form.valid) {



      this.service.idDocumentServices = 0;
      this.service.documentsIdDocument = this.selectedDocument.idDocument;
      this.service.nServicesIdService = this.idService;
      this.service.isRequired = this.isRequiredSelected;
      this.service.isDownloadable = this.Form.value.isDownloadable;
      this.service.order = this.order;
      this.service.isActive = this.Form.value.isActive;

      this.client.create(this.service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public trimTitle(title: string): string {
    return title.length > 15 ? title.substring(0, 15) : title;
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

}
